export const formatReports = (reports: {[key: number]: boolean}) => {
  return (
    reports &&
    Object.entries(reports)
      .filter(([key, value]) => value === true)
      .map(([key]) => ({ id: parseFloat(key) }))
  );
};
